import React from "react";
import {Helmet} from "react-helmet";
import {useLocation} from "react-router-dom";
import {useSelector} from "react-redux";
import {alternateLinks, detectSite, htmlLang, isDetailPath, siteUrl} from "../../uitls/Seo";
import {stringsTranslate} from "../../locales/CustomTranslater";
import {appWords} from "../../config/Constants";

// Sets <html lang>, a default meta description, and the canonical and hreflang links for the current page.
// Pages with their own <meta name="description"> in a Helmet override the default.
// Detail pages render their own <SeoHead path={...}/> with a path built from the loaded data,
// so the global instance leaves those pages alone. That instance sets no description: detail pages
// have their own, and Helmet lets the last mounted instance win, so a default here would replace it
// when this instance mounts later (the cashback page waits for its hreflang pairs).
// sitePaths: see alternateLinks() in Seo.js.
export default function SeoHead({path, sitePaths}) {
    useLocation(); // re-render on navigation
    const appLanguageRS = useSelector((state) => state.appLanguageRS);
    const site = detectSite();
    const currentPath = path || window.location.pathname;
    const lang = htmlLang(appLanguageRS || site);
    const description = path ? null : <meta name="description" content={stringsTranslate(appWords.seo_default_description)}/>;

    if (currentPath === "/404" || (!path && isDetailPath(currentPath))) {
        return <Helmet htmlAttributes={{lang}}>{description}</Helmet>;
    }

    return (
        <Helmet htmlAttributes={{lang}}>
            {description}
            <link rel="canonical" href={siteUrl(currentPath, site)}/>
            {alternateLinks(currentPath, site, sitePaths).map(link => (
                <link key={link.hreflang} rel="alternate" hrefLang={link.hreflang} href={link.href}/>
            ))}
        </Helmet>
    );
}
